module.exports = __webpack_public_path__ + "static/media/quote-left.a2015d7d.svg";